import { render, staticRenderFns } from "./ProviderCredentials.vue?vue&type=template&id=316d0d0a&scoped=true&"
import script from "./ProviderCredentials.vue?vue&type=script&lang=js&"
export * from "./ProviderCredentials.vue?vue&type=script&lang=js&"
import style0 from "./ProviderCredentials.vue?vue&type=style&index=0&id=316d0d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d0d0a",
  null
  
)

export default component.exports